import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import banko.composeapp.generated.resources.Res
import banko.composeapp.generated.resources.update_required_button
import banko.composeapp.generated.resources.update_required_message
import banko.composeapp.generated.resources.update_required_title
import org.jetbrains.compose.resources.stringResource

/**
 * Full-screen, non-dismissable gate shown instead of the app when this build is below the remote
 * minimum (see [AppUpdateGate]). Deliberately has no back/skip affordance: builds below the minimum
 * are known-incompatible with the live backend or other players.
 */
@Composable
fun UpdateRequiredScreen(requirement: UpdateRequirement) {
    Column(
        modifier = Modifier.fillMaxSize().padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
    ) {
        Text(
            text = stringResource(Res.string.update_required_title),
            style = MaterialTheme.typography.headlineMedium,
            color = MaterialTheme.colorScheme.onSurface,
            textAlign = TextAlign.Center,
        )
        Spacer(Modifier.height(12.dp))
        Text(
            text = requirement.message ?: stringResource(Res.string.update_required_message),
            style = MaterialTheme.typography.bodyLarge,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
            textAlign = TextAlign.Center,
        )
        val storeUrl = requirement.storeUrl
        if (storeUrl != null) {
            Spacer(Modifier.height(24.dp))
            val uriHandler = LocalUriHandler.current
            Button(onClick = { uriHandler.openUri(storeUrl) }) {
                Text(stringResource(Res.string.update_required_button))
            }
        }
    }
}
